import { useForm } from '@mantine/form';

export const useManagerForm = () => {
  return useForm({
    initialValues: {
      username: '',
      password: '',
      email: '',
    },

    validate: {
      username: (v) => {
        if (!v || v.length < 6) {
          return 'Username should be at least 6 characters long';
        }
      },
      password: (v) => {
        if (!v || v.length < 6) {
          return 'Password should be at least 6 characters long';
        }
      },
      email: (v) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (v && !emailRegex.test(v)) {
          return 'Invalid email address';
        }
      },
    },
  });
};
